import { FadeUp } from "./Reveal";
import { useI18n } from "@/context/Language";

const Embed = ({ id, vertical }) => (
  <div className={`relative w-full overflow-hidden border border-border-soft bg-ink ${vertical ? "aspect-[9/16]" : "aspect-video"}`}>
    <iframe
      className="absolute inset-0 h-full w-full"
      src={`https://www.youtube.com/embed/${id}?rel=0`}
      title="Video"
      loading="lazy"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    />
  </div>
);

export const Videos = () => {
  const { t, N } = useI18n();
  const V = t.videos;

  return (
    <section id="videos" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <FadeUp>
          <span className="text-xs uppercase tracking-[0.24em] text-terracotta">{V.overline}</span>
          <h2 className="mt-4 max-w-2xl font-serif text-4xl sm:text-5xl tracking-tight text-ink">{V.heading}</h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-ink/70">{V.intro}</p>
        </FadeUp>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-5 items-start">
          <FadeUp className="lg:col-span-7">
            <Embed id={N.video.featured} />
          </FadeUp>
          <div className="lg:col-span-5 grid grid-cols-2 gap-5">
            {N.video.shorts.map((id, i) => (
              <FadeUp key={id} delay={i * 0.1}>
                <Embed id={id} vertical />
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Videos;
